import i18n from '../../i18n';
import { sanitizeFilename } from './inputSanitizer';
import { getBrandLocale } from './brandCurrency';

const REPORT_TYPE_I18N_KEYS = {
  tva: 'common.export_files.filename_prefix.tva',
  articles: 'common.export_files.filename_prefix.articles',
  purchased_items: 'common.export_files.filename_prefix.purchased_items',
  categories: 'common.export_files.filename_prefix.categories',
  purchases_ledger: 'common.export_files.filename_prefix.purchases_ledger',
  sales_ledger: 'common.export_files.filename_prefix.sales_ledger',
  replenishment_report: 'common.export_files.filename_prefix.replenishment_report',
  locations_report: 'common.export_files.filename_prefix.locations_report',
  lots_report: 'common.export_files.filename_prefix.lots_report',
  picking_report: 'common.export_files.filename_prefix.picking_report',
  stock_alerts_report: 'common.export_files.filename_prefix.stock_alerts_report',
  journal_caisse: 'common.export_files.filename_prefix.journal_caisse',
  employees: 'common.export_files.filename_prefix.employees',
  import_template: 'common.export_files.filename_prefix.import_template',
};

export const slugifyExportName = (text) =>
  sanitizeFilename(
    String(text || '')
      .trim()
      .replace(/\s+/g, '_')
      .replace(/[/\\?%*:|"<>]/g, '')
  );

export const formatExportDate = (date = new Date(), locale) => {
  const loc = locale || getBrandLocale(i18n.language);
  return date.toLocaleDateString(loc).replace(/\//g, '-');
};

export const getReportFilenamePrefix = (reportType) => {
  const key = REPORT_TYPE_I18N_KEYS[reportType] || 'common.export_files.filename_prefix.report';
  return slugifyExportName(i18n.t(key));
};

export const buildReportPdfFilename = (reportType, date = new Date()) => {
  const prefix = getReportFilenamePrefix(reportType);
  const dateStr = formatExportDate(date);
  return sanitizeFilename(`${prefix}-${dateStr}.pdf`);
};

export const buildReportExcelFilename = (nameSlug, date = new Date()) => {
  const titleSlug = slugifyExportName(nameSlug);
  const suffix = slugifyExportName(i18n.t('common.export_files.filename_suffix_professional'));
  const dateStr = formatExportDate(date);
  return sanitizeFilename(`${titleSlug}_${suffix}_${dateStr}.xlsx`);
};

export const buildExportFilename = (
  nameKeyOrText,
  { ext = 'xlsx', suffix, date = new Date(), isKey = true, interpolation = {} } = {}
) => {
  const base = isKey
    ? i18n.t(nameKeyOrText, interpolation)
    : nameKeyOrText;
  let name = slugifyExportName(base);
  if (suffix) {
    name += `_${slugifyExportName(suffix)}`;
  }
  name += `_${formatExportDate(date)}`;
  return sanitizeFilename(`${name}.${String(ext).replace(/^\./, '')}`);
};

export const truncateSheetName = (name, maxLen = 31) => {
  const resolved = String(name || i18n.t('common.data_sheet'));
  return resolved.length <= maxLen ? resolved : resolved.substring(0, maxLen);
};

export const resolveReportExcelFilename = (reportType, reportTitle, date = new Date()) => {
  const slug = REPORT_TYPE_I18N_KEYS[reportType]
    ? getReportFilenamePrefix(reportType)
    : slugifyExportName(reportTitle);
  return buildReportExcelFilename(slug, date);
};
